module.exports = __webpack_public_path__ + "img/y.0b10d51a.svg";